<template>
  <header>
    <div class="wrap">
      <router-link to="/">Galvanic/Voltaic Cells</router-link>
    </div>
  </header>
</template>

<script>
export default {
  name: "Headbar",
};
</script>

<style lang="scss" scoped>
header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding-top: 3rem;
  font-size: 1.125rem;
  letter-spacing: 0.087rem;
  font-weight: 900;
  text-transform: uppercase;
  padding: 3rem var(--pad2) 0;

  a {
    color: var(--lighttext);
    text-decoration: none;
  }

  @media screen and (min-width: calc(1440px + 2rem)) {
    padding: 3rem 0 0;
  }
}
</style>
